import { TOPCON_COLORS } from '../topconThemeConf';
export const topconSentryReportStyle = {
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]': {
        backgroundColor: `${TOPCON_COLORS.success.main} !important`,
        border: 'none !important',
        outline: 'none !important',
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:hover': {
        backgroundColor: `${TOPCON_COLORS.success.dark} !important`,
    },
    '.sentry-error-embed-wrapper .form-submit button[type="submit"]:active': {
        backgroundColor: `${TOPCON_COLORS.success.main} !important`,
    },
};
//# sourceMappingURL=topconSentryReportStyle.js.map